/** Gestão de cobrança. */

import { httpV1 as http } from '@/services/api';

export async function collectionKPIs() {
  return http.get('/collection/kpis');
}

export async function collectionInsights() {
  return http.get('/collection/insights');
}

export async function collectionDebts(params) {
  return http.get('/collection/companies', { params });
}

export async function collectionDebtsDetails(id) {
  return http.get(`/collection/companies/${id}/details`);
}

export async function collectionInterventions(data) {
  return http.post('/collection/interventions', data);
}
